export default __webpack_public_path__ + "static/media/Member_ShuoWei.cf53b2bd.jpg";